import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { updateOrder } from '../../api/ans';
import resetStore from '../resetStore';

const initialState = {
  order_no: '',
  grms: [],
  items: [],
  stocks: [],
};

export const updateOrderThunk = createAsyncThunk(
  'orders/updateOrder',
  async (asnData, { rejectWithValue }) => {
    try {
      const result = await updateOrder(asnData);
      return result;
    } catch (err) {
      console.error(err, 'Error in getAllOrdersThunk');
      return rejectWithValue(
        err.response?.data?.message || err.message || 'Ошибка создания ASN'
      );
    }
  }
);

const updateOrderSlice = createSlice({
  name: 'updateOrder',
  initialState,
  reducers: {
    updateStocksOrder(state, action) {
      state.stocks = [...state.stocks, action.payload.newElement];
    },
    clearStocks(state) {
      state.stocks = [];
      console.log(state.stocks, 'clear stocks');
    },
    clearSelectedStocks(state, action) {
      const idsToRemove = action.payload.map((item) => item.grm);
      state.stocks = state.stocks.filter((stock) => !idsToRemove.includes(stock.grm));
    },
    updateOrderForm(state, action) {
      state.order_no = action.payload.order_no || '';
      state.items = action.payload.items || [];
      console.log(JSON.parse(JSON.stringify(state)), 'updateOrderForm state');
    },
    setGrms(state, action) {
      state.grms = action.payload;
      console.log(JSON.parse(JSON.stringify(state)), 'setGrms state');
    },
    setOrderNumber(state, action) {
      state.order_no = action.payload;
      console.log(JSON.parse(JSON.stringify(state)), 'setOrderNumber state');
    },
    clearGrms(state) {
      state.grms = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateOrderThunk.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(updateOrderThunk.fulfilled, (state) => {
        state.status = 'resolved';
      })
      .addCase(updateOrderThunk.rejected, (state, action) => {
        state.status = 'rejected';
        state.error = action.payload;
      })
      .addCase(resetStore, () => initialState);
  },
});

export const {
  updateOrderForm,
  clearGrms,
  setGrms,
  setOrderNumber,
  updateStocksOrder,
  clearStocks,
  clearSelectedStocks,
} = updateOrderSlice.actions;
export default updateOrderSlice.reducer;
